import { render } from "./upcoming-coach.vue?vue&type=template&id=62089e7e"
import script from "./upcoming-coach.vue?vue&type=script&lang=js"
export * from "./upcoming-coach.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__